"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalDirectionSchema = exports.SignalDirection = void 0;
const zod_1 = require("zod");
var SignalDirection;
(function (SignalDirection) {
    SignalDirection["BiDirectionalIO"] = "biio";
    SignalDirection["Input"] = "input";
    SignalDirection["Output"] = "output";
})(SignalDirection || (exports.SignalDirection = SignalDirection = {}));
exports.SignalDirectionSchema = zod_1.z.nativeEnum(SignalDirection);
//# sourceMappingURL=SignalDirection.js.map